module.exports = __webpack_public_path__ + "img/body-model-arm-left.f931aa98.svg";